module.exports = __webpack_public_path__ + "img/bank-right-type2.ac6bc041.png";